import React from 'react';
import { Button, Input } from 'reactstrap';

const Pagination = ({ pagination, onPageChange, onLimitChange }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
      <div className="d-flex align-items-center gap-2">
        <span className="text-muted small">Hiển thị:</span>
        <Input
          type="select"
          value={pagination.limit}
          onChange={(e) => onLimitChange(e.target.value)}
          style={{ width: '80px' }}
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </Input>
        <span className="text-muted small">
          / {pagination.total} users
        </span>
      </div>

      <div className="d-flex gap-2">
        <Button
          color="light"
          size="sm"
          onClick={() => onPageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
        >
          « Trước
        </Button>
        <span className="px-3 py-2 bg-light rounded small">
          Trang {pagination.page} / {pagination.totalPages}
        </span>
        <Button
          color="light"
          size="sm"
          onClick={() => onPageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
        >
          Sau »
        </Button>
      </div>
    </div>
  );
};

export default Pagination;

